<template>
  <div class="page-actus">
    <main class="p-6">
      <breadcrumbs></breadcrumbs>

      <div class="page_title">
        <h1>Actualités</h1>
      </div>

      <router-view />
        <form v-on:submit.prevent class="filters mb-3" @change="filterNews">
        <label>
          Filtrer par catégorie :
          <select v-model="selectedTag">
            <option value="">Toutes les catégories</option>
            <option v-for="tag in tags" :key="tag" :value="tag">
              {{ tag }}
            </option>
          </select>
        </label>
        <label>
          Rechercher par mots clés :
          <input v-model="keywords" type="text" />
        </label>
      </form>
      <div class="grid xl:grid-cols-4 sm:grid-cols-3 sm:max-w-full max-w-xs relative mt-5">
        <!-- <div class="grid-sizer"></div> -->
        <article
          v-masonry-tile
          v-for="(article, i) in news.results"
          :key="i"
          class="w-11/12 mr-10 mb-6 bg-white"
          :class="article.forwarded ? 'actu--en-avant' : ''"
        >
          <div class="flex flex-col">
            <div
              v-if="article.thumbnail.find((thumb) => thumb.size == 600)"
              class="actu-image"
            >
              <router-link
                v-if="article.thumbnail"
                :to="{ name: 'article', params: { slug: article.slug } }"
                :title="'Accéder à l\'article ' + article.title"
              >
                <img
                  :src="
                    article.thumbnail.find((thumb) => thumb.size == 600).file
                  "
                  :alt="article.title"
                  class="rounded-t"
                />
              </router-link>
            </div>
            <div class="actu-content">
              <router-link
                :to="{ name: 'article', params: { slug: article.slug } }"
                :title="'Accéder à l\'article ' + article.title"
              >
                <h2 class="actu_titre">{{ article.title }}</h2>
              </router-link>
              <div class="actu_date">
                <span class="grey">Le </span>
                <span class="orange">{{ article.news_date }}</span>
                <span v-if="article.tags[0]" class="grey">
                  - {{ "Catégorie" | pluralize(article.tags) }} :
                  <span
                    v-for="(tag, i) in article.tags"
                    :key="tag"
                    class="orange"
                  >
                    <span v-if="i !== 0">, </span>
                    <router-link
                      :to="{ name: 'news', query: { categorie: tag } }"
                      >{{ tag }}</router-link
                    >
                  </span>
                </span>
              </div>
              <div class="actu_texte rte excerpt-text">
                {{
                  parseHTML(article.text).textContent.substring(0, 250) + ".."
                }}
              </div>
              <div class="read">
                <router-link
                  class="orange lire-la-suite"
                  :to="{ name: 'article', params: { slug: article.slug } }"
                  :title="'Accéder à l\'article ' + article.title"
                >
                  Lire la suite ›
                </router-link>
              </div>
            </div>
          </div>
        </article>
        

        <!-- <div class="bg-orange px-1 rounded-md absolute left-0 bottom-0 mt-12" v-if="previousPage">
          <button @click="loadPrevious">Précédent</button>
        </div>
        <div
          class="bg-orange px-1 rounded-md absolute right-7 bottom-0 mt-12"
          v-if="news.next"
        >
          <button @click="loadMore">Suivant</button>
        </div> -->
      </div>
      <pagination-item
        class="-flex"
        :items="news"
        :page="page"
        @changePage="
          $emit('update:page', $event)
          $emit('changePage')
        "
      ></pagination-item>
      <div v-if="!news.results">Aucune actualité pour le moment</div>
    </main>
  </div>
</template>

<script>
import PaginationItem from '@/components/PaginationItem'
import News from '@/api/news.js'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  name: 'News',
  components: { Breadcrumbs, PaginationItem },

  props: {
    mainMenuDisplay: Boolean
  },

  data() {
    return {
      page: 1,
      news: {},
      tags: [],
      selectedTag: '',
      keywords: '',
      busy: false,
      busyPrevious: false,
      previousPage: null
    }
  },

  created() {
    this.selectedTag = this.$route.query.categorie || ''
    this.keywords = this.$route.query.keywords || ''
    this.page = Number(this.$route.query.page) || 1

    this.getNews()

    News.listTags().then((response) => {
      this.tags = response;
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.selectedTag = to.query.categorie || ''
    this.keywords = to.query.keywords || ''
    this.page = Number(to.query.page) || 1
    this.getNews()

    next()
  },

  methods: {
    getNews() {
      this.busy = true
      News.list({
        page: this.page,
        tag: this.selectedTag,
        keywords: this.keywords
      })
        .then((response) => {
          if (this.$route.params.loadMore) {
            this.news.next = response.next
            this.news.previous = response.previous
            this.news.results.push(...response.results)
          } else {
            this.news = response
            this.previousPage = this.news.previous ? this.page - 1 : null
          }
        })
        .finally(() => {
          this.busy = false
        })
    },
    // loadMore() {
    //   if (this.news.next) {
    //     this.$router.replace({
    //       name: 'news',
    //       params: { loadMore: true },
    //       query: {
    //         page: this.page + 1,
    //         categorie: this.selectedTag,
    //         keywords: this.keywords
    //       }
    //     })
    //   }
    // },
    // loadPrevious() {
    //   this.$router.replace({
    //     name: "news",
    //     params: { loadPrevious: true },
    //     query: {
    //       page: this.page - 1,
    //       categorie: this.selectedTag,
    //       keywords: this.keywords,
    //     },
    //   });
    // },
    filterNews() {
      this.$router.push({
        name: 'news',
        query: {
          page: 1,
          categorie: this.selectedTag,
          keywords: this.keywords
        }
      })
    },
    parseHTML(html) {
      var t = document.createElement("template");
      t.innerHTML = html;
      return t.content;
    },
  },

  watch: {
    mainMenuDisplay() {
      setTimeout(() => this.$redrawVueMasonry(), 500)
    }
  }
}
</script>
